import React from 'react';
import { ChevronDown } from 'lucide-react';

export type ExchangeFilterOption = 'all' | 'bybit' | 'binance' | 'gate' | 'aster' | 'kucoin' | 'hyperliquid';

interface ExchangeFilterSelectProps {
  value: ExchangeFilterOption;
  onChange: (value: ExchangeFilterOption) => void;
  className?: string;
}

const exchangeOptions: { value: ExchangeFilterOption; label: string }[] = [
  { value: 'all', label: 'All Exchanges' },
  { value: 'binance', label: 'Binance' },
  { value: 'bybit', label: 'Bybit' },
  { value: 'gate', label: 'Gate.io' },
  { value: 'kucoin', label: 'KuCoin' },
  { value: 'aster', label: 'Aster' },
  { value: 'hyperliquid', label: 'Hyperliquid' },
];

/**
 * Exchange filter dropdown select for desktop.
 * Replaces the drawer-based filter on mobile.
 */
export const ExchangeFilterSelect: React.FC<ExchangeFilterSelectProps> = ({
  value,
  onChange,
  className = '',
}) => {
  return (
    <div className={`relative ${className}`}>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as ExchangeFilterOption)}
        className="appearance-none w-full bg-secondary border border-border rounded-lg px-4 py-2 pr-10 text-sm text-text-primary focus:outline-none focus:border-accent cursor-pointer hover:border-accent/50 transition-colors"
      >
        {exchangeOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-text-secondary pointer-events-none" />
    </div>
  );
};
